import { ReactElement, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import ProgressModal from "../../../../components/Progress/ProgressModal/ProgressModal";
import { AppContext } from "../../../../core/context/appContextProvider";
import RoutingPaths from "../../../../core/routing/routingPaths";
import { downloadContactAccountReport } from "../../../../services/capitalAccounts.service";
import downloadFile from "../../../../utils/helpers/fileDownloader";
import { DOWNLOAD_ERROR } from "../../constants";
import useDocuments from "../../hooks/useDocuments.hooks";

type Params = {
  document_id?: string;
  report_id?: string;
};

function Download(): ReactElement {  
  const { informationAlert } = useContext(AppContext);
  const { ...actions } = useDocuments();
  const history = useHistory();
  const params = useParams<Params>();

  const fileId = params?.document_id || params?.report_id || "";
  
  useEffect(() => {

    if(fileId) {
      const isReport = !params.document_id;

      if(isReport) {
        downloadContactAccountReport(fileId)
          .then((fileBlob: any) => {
            downloadFile(fileBlob, `Capital_Account_Report`, "zip");
            history.push(RoutingPaths.CapitalAccounts);
          })
          .catch(() => {
            informationAlert(DOWNLOAD_ERROR, "error");
            history.push(RoutingPaths.CapitalAccounts);
          });
      } else {
        actions
          .downloadFiles("", fileId, "document")
          .then(() => {
            history.push(RoutingPaths.Documents);
          })
          .catch(() => {
            informationAlert(DOWNLOAD_ERROR, "error");
            history.push(RoutingPaths.Documents);
          });
      }
    } else {
      history.push(RoutingPaths.Documents);
    }
  }, [fileId]);

  return (<ProgressModal id="documents_progress_modal" showProgress={true} />);
}

export default Download;
